export default __webpack_public_path__ + "static/media/List-documentation.839bae3b.md";